
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Reset Icon","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 31 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Subtraction 22","d":"M29.434 22H9.888a1.574 1.574 0 01-1.175-.524L.391 12.048a1.6 1.6 0 010-2.1L8.713.524A1.579 1.579 0 019.888 0h19.546A1.572 1.572 0 0131 1.573v18.856A1.57 1.57 0 0129.434 22zm-10.45-9.221l3.363 3.373a1.235 1.235 0 00.881.365 1.256 1.256 0 00.89-2.143L20.754 11l3.365-3.374a1.26 1.26 0 000-1.774 1.247 1.247 0 00-1.768 0l-3.363 3.375-3.365-3.374a1.248 1.248 0 00-1.768 0 1.261 1.261 0 000 1.776L17.216 11l-3.361 3.37a1.261 1.261 0 000 1.776 1.247 1.247 0 001.768 0l3.36-3.369z","fill":"#243782"}})])
          )
        }
      }
    